<template>
  <el-dialog  title="人车维护"  :visible.sync="dialog" width="1100px" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  center>
    <div>
 <el-form :inline="true" :model="addFrom" ref="addFrom"  :rules="rules"  class="demo-form-inline jiaoyan" label-width="120px" size="mini" >
      <div class="addressBox" style="margin-bottom:-30px">
        <h4 class="title">
          <span><i class="fa fa-truck" aria-hidden="true"></i>人车信息</span>
           <el-form-item style="margin-left:16px">
             <el-button type="primary" @click="addFN">新增</el-button>
          </el-form-item>
        </h4>
      </div>
       <el-table :data="addFrom.carLIst"  ref="table"   bordersize="mini"    style="width: 100%" height="300"   center border v-if="rowData.janFaFlag">
         <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="提货车号" width="270">
            <template slot="header" >
              <div><span class="red">*</span>提货车号</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.vhcNo'"
              :key="scope.$index" :rules="rules.vhcNo" class="table_error" v-if="!scope.row.id">
                <!-- <el-input  placeholder=""     maxlength="10"     v-model="addFrom.carriageInfos[scope.$index].vhcNo"></el-input> -->
                <el-autocomplete class="inline-input" v-model.trim="addFrom.carLIst[scope.$index].vhcNo"
                  :fetch-suggestions="querySearch" value-key="vhcNo" @select="handleSelect($event,scope.$index)" popper-class="xiala">
                   <template slot-scope="{ item }">
                       <div style="position: relative;">
                        <div class="name">{{ item.vhcNo }},{{ item.driverName }}</div>
                        <span class="addr">{{ item.driverIdentityNo? item.driverIdentityNo:''}}</span>
                        <span class="el-icon-close" style="position: absolute; right: 0;top: 4px;" @click.stop="delRenche(item)"></span>
                     </div>
                  </template>
                </el-autocomplete>
              </el-form-item>
              <div v-if="scope.row.id">{{scope.row.vhcNo}}</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="司机姓名" width="170">
           <template slot="header" >
              <div><span class="red" v-if="tableArr[3]">*</span>司机姓名</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverName'"
              :key="scope.$index" :rules="tableArr[3]?rules.driverName:[{required: false}]" class="table_error" v-if="!scope.row.id" >
                <el-input  placeholder=""  maxlength="10"     v-model.trim="addFrom.carLIst[scope.$index].driverName"></el-input>
              </el-form-item>
              <div v-if="scope.row.id">{{scope.row.driverName}}</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="身份证号" min-width="170">
            <template slot="header" >
              <div><span class="red" v-if="tableArr[1]" >*</span>身份证号</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverIdentityNo'"
              :key="scope.$index" :rules="tableArr[1]?rules.driverIdentityNo:[{required: false}]" class="table_error"   v-if="!scope.row.id">
                <el-input  placeholder=""  maxlength="18"     v-model.trim="addFrom.carLIst[scope.$index].driverIdentityNo"></el-input>
              </el-form-item>
              <div v-if="scope.row.id">{{scope.row.driverIdentityNo}}</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="联系电话" width="170">
           <template slot="header" >
              <div><span class="red" v-if="tableArr[2]">*</span>联系电话</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverMobile'"
               :key="scope.$index" :rules="tableArr[2]?rules.driverMobile:[{required: false}]" class="table_error"  v-if="!scope.row.id">
                <el-input  placeholder=""   maxlength="11"     v-model.trim="addFrom.carLIst[scope.$index].driverMobile"></el-input>
              </el-form-item>
              <div v-if="scope.row.id">{{scope.row.driverMobile}}</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div>
               <el-button type="text" size="mini"  v-if="!scope.row.id"  @click="zhipai(scope.$index)">指派</el-button>
              <el-button type="text" size="mini"  @click="delFN(scope.$index,scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
       </el-table>
       <el-table :data="addFrom.carLIst"  ref="table"   bordersize="mini"    style="width: 100%" height="500"   center border v-else>
         <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="提货车号" width="300">
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.vhcNo'" :key="scope.$index" :rules="rules.vhcNo1"  v-if="!scope.row.id">
                <el-input  placeholder="请输入提货车号"  type="textarea"    maxlength="200"     v-model="addFrom.carLIst[scope.$index].vhcNo"></el-input>
              </el-form-item>
               <div v-if="scope.row.id">{{scope.row.vhcNo}}</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="提货单位/人" width="170">
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverName'" :key="scope.$index" :rules="rules.driverName"  v-if="!scope.row.id">
                <el-input  placeholder="请输入提货单位/人"  type="textarea"  maxlength="100"     v-model="addFrom.carLIst[scope.$index].driverName"></el-input>
              </el-form-item>
              <div v-if="scope.row.id">{{scope.row.driverName}}</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="纳税人识别号/身份证号" min-width="170">
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverIdentityNo'" :key="scope.$index" :rules="rules.driverIdentityNo1"  v-if="!scope.row.id">
                <el-input  placeholder="请输入纳税人识别号/身份证号" type="textarea"  maxlength="30"     v-model="addFrom.carLIst[scope.$index].driverIdentityNo"></el-input>
              </el-form-item>
               <div v-if="scope.row.id">{{scope.row.driverIdentityNo}}</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <div>
            <el-button type="text" size="mini"  v-if="!scope.row.id"   @click="delFN(scope.row,scope.$index)">删除</el-button>
              </div>
          </template>
        </el-table-column>
       </el-table>
 </el-form>
    </div>
     <span slot="footer" class="dialog-footer">
       <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
       <!-- 指派 -->
      <zhipai   v-if="zhipaiFlag" @destroy="destroy" @zhipaiSave="zhipaiSave"></zhipai>
   </el-dialog>

</template>

<script>
import { addBillCarriageInfos, goodsDetail } from '@/api/soc-stock'
import { sBillCarriageInfoList, sCarriageLogDelete, checkWhBillDriver } from '@/api/soc-stock-cosco'
import zhipai from '@/views/soc-stock-cosco/inventoryMonitore/zhipai.vue'
export default {
  name: 'lookVoucher',
  components: {
    zhipai
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      zhipaiFlag: false,
      dialog: true,
      addFrom: {
        id: this.rowData.id,
        carLIst: []
      },
      tableList: [],
      rules: {
        driverName: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        driverIdentityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        driverMobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        driverIdentityNo1: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        vhcNo1: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ]
      },
      currentIndx: 0,
      carDerList: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      callback: null,
      searchStr: '',
      tableArr: this.rowData.tableArr,
      delIds: []

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    goodsDetail({ id: this.rowData.id }).then(res => {
      this.addFrom.carLIst = res.carriageList
      this.addFrom.carLIst.push({})
    })

    sBillCarriageInfoList({ isDistinct: '1', billCategory: 1 }).then(res => {
      this.carDerList = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
  },
  methods: {
    // 删除下拉得人车
    delRenche (item) {
      sCarriageLogDelete({ id: item.id }).then(res => {
        sBillCarriageInfoList({ isDistinct: '1', billCategory: 2 }).then(res => {
          this.carDerList = res
          this.querySearch(this.searchStr, this.callback)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 指派
    zhipai (index) {
      this.currentIndx = index
      this.zhipaiFlag = true
    },
    zhipaiSave (row) {
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverName', row.driverName)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverMobile', row.driverMobile)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'vhcNo', row.vhcNo)
      this.zhipaiFlag = false
    },
    destroy () {
      this.zhipaiFlag = false
    },
    querySearch (str, cb) {
      let arr = []
      this.carDerList.forEach(itme => {
        if (str) {
          if (itme.vhcNo.indexOf(str) != -1) {
            arr.push(itme)
          }
        } else {
          arr.push(itme)
        }
      })
      this.callback = cb
      this.searchStr = str
      cb(arr)
    },
    handleSelect (row, index) {
      this.$set(this.addFrom.carLIst[index], 'driverName', row.driverName)
      this.$set(this.addFrom.carLIst[index], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.carLIst[index], 'driverMobile', row.driverMobile)
    },
    // 添加人车
    addFN () {
      this.addFrom.carLIst.push({})
    },
    // 删除人车
    delFN (n, data) {
      if (data.id) {
        checkWhBillDriver({
          billNo: this.rowData.billNo,
          organizationId: this.rowData.organizationId,
          driverName: data.driverName,
          plateNumber: data.vhcNo
        }).then(res => {
          if (res == 1) {
            this.$alert('已使用的人车信息不能删除', '系统提示')
          } else {
            this.delIds.push(data.id)
            this.addFrom.carLIst.splice(n, 1)
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.addFrom.carLIst.splice(n, 1)
      }
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          let arr = []
          let carLIst = this.addFrom.carLIst
          const ids = []
          this.addFrom.carLIst.forEach((item) => {
            if (item.driverIdentityNo) {
              ids.push(item.driverIdentityNo)
            }
            if (!item.id) {
              arr.push(item)
            }
          })
          this.addFrom.carriageInfos = arr
          // if (this.addFrom.carriageInfos.length == 0) {
          //   this.$alert('请维护人车信息', '系统提示')
          //   return
          // }
          if (ids.length > 0) {
            const idsSet = new Set(ids)
            if ([...idsSet].length != ids.length) {
              this.$alert('人车信息身份证号不能重复', '系统提示')
              return
            }
          }
          this.addFrom.deleteCarriageIds = this.delIds
          delete this.addFrom.carLIst
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let that = this
          addBillCarriageInfos(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$emit('destroy')
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                that.addFrom.carLIst = carLIst
                loading.close()
              }
            })
          })
        }
      })
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
.table_error /deep/.el-form-item__error{
    // top: 8px;
    // left: 5px;
}

/deep/.jiaoyan .el-form-item--mini.table_error{
  margin-bottom: 0 !important;
    margin: 6px 0!important;
}
.xiala{
  .name{
    color: #000;
    line-height:normal;
    margin-top:6px;
  }
  .addr{
    color: #999;
  }
}
/deep/.el-autocomplete {
  width: 210px;
}
</style>
